var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmnHealthcareLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "amn-healthcare-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 314,
    height: 112.455,
    viewBox: "0 0 314 112.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6034",
    "data-name": "Rectangle 6034",
    width: 314,
    height: 112.455,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6035",
    "data-name": "Rectangle 6035",
    width: 314,
    height: 106.306,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26829",
    "data-name": "Path 26829",
    d: "M62.824,4.117h5.72L94.02,58.542H85.69L78.124,42.513H53.876l-7.1,16.029H38.42Zm11.952,31.5-9.16-19.6-8.506,19.6Z",
    transform: "translate(86.596 9.279)",
    fill: "#153e68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26830",
    "data-name": "Path 26830",
    d: "M101.975,4.116h7.549V58.554H101.35V16.172L83.88,37.095H82.373L64.7,16.172V58.544H56.573V4.116H64.23L83.148,26.392Z",
    transform: "translate(127.511 9.277)",
    fill: "#153e68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26831",
    "data-name": "Path 26831",
    d: "M117.662,4.118h7.36V58.55l-6.433-.007L82.178,16.636V58.544H74.9V4.122H81.11l36.551,42.109Z",
    transform: "translate(168.815 9.283)",
    fill: "#153e68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26832",
    "data-name": "Path 26832",
    d: "M38.426,24.305h2.645V36.153H54.6V24.305h2.649V51.059H54.6V38.447H41.071V51.059H38.426Z",
    transform: "translate(86.608 54.783)",
    fill: "#153e68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11602",
    "data-name": "Group 11602",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11601",
    "data-name": "Group 11601",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26833",
    "data-name": "Path 26833",
    d: "M60.084,45.771a15.872,15.872,0,0,1-5.672,1.08c-6.475,0-8.9-4.37-8.9-10.237,0-5.984,3.3-10.237,8.249-10.237,5.515,0,7.777,4.448,7.777,9.7V37.3H48.161c0,4.142,2.226,7.481,6.443,7.481a12.521,12.521,0,0,0,5.48-1.461ZM58.9,35.229c0-3.407-1.383-6.784-4.988-6.784-3.566,0-5.75,3.573-5.75,6.784Z",
    transform: "translate(102.589 59.454)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26834",
    "data-name": "Path 26834",
    d: "M63.905,43.246h-.075a6.891,6.891,0,0,1-6.215,3.605c-5.558,0-6.44-3.758-6.44-5.519,0-6.56,6.976-6.863,12.033-6.863h.462v-1c0-3.329-1.184-5.024-4.438-5.024a10.475,10.475,0,0,0-5.759,1.611V27.722a15.451,15.451,0,0,1,5.759-1.344c4.826,0,6.856,2.183,6.856,7.289V42.29a27.778,27.778,0,0,0,.192,4.1H63.905Zm-.234-6.71h-.69c-4.175,0-9.157.433-9.157,4.712,0,2.571,1.832,3.534,4.061,3.534,5.668,0,5.785-4.952,5.785-7.061Z",
    transform: "translate(115.347 59.454)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6033",
    "data-name": "Rectangle 6033",
    width: 2.414,
    height: 28.755,
    transform: "translate(186.918 77.089)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26835",
    "data-name": "Path 26835",
    d: "M70.261,32.442H65.816V45.09c0,1.76.648,3.221,2.606,3.221a5.641,5.641,0,0,0,2.226-.462l.156,1.995a8.759,8.759,0,0,1-2.958.537c-4.3,0-4.445-2.951-4.445-6.524V32.442h-3.84V30.373H63.4V25.652l2.414-.84v5.561h4.445Z",
    transform: "translate(134.248 55.924)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26836",
    "data-name": "Path 26836",
    d: "M64.479,23.691H66.9V36.2h.075a6.623,6.623,0,0,1,6.095-3.762c5.252,0,6.671,3.491,6.671,8.317V52.446H77.329V40.8c0-3.381-.654-6.3-4.64-6.3-4.292,0-5.785,4.067-5.785,7.481V52.446H64.479Z",
    transform: "translate(145.33 53.398)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26837",
    "data-name": "Path 26837",
    d: "M84.632,29.445a11.007,11.007,0,0,0-4.181-1c-4.708,0-7.357,3.417-7.357,8.171,0,4.445,2.684,8.167,7.1,8.167A12.584,12.584,0,0,0,84.6,43.9l.228,2.258a14.437,14.437,0,0,1-5.018.69c-6.3,0-9.352-4.79-9.352-10.234,0-6.016,3.866-10.24,9.654-10.24a14.65,14.65,0,0,1,4.715.771Z",
    transform: "translate(158.807 59.452)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26838",
    "data-name": "Path 26838",
    d: "M88.607,43.246h-.068a6.9,6.9,0,0,1-6.222,3.605c-5.554,0-6.433-3.758-6.433-5.519,0-6.56,6.973-6.863,12.036-6.863h.452v-1c0-3.329-1.184-5.024-4.445-5.024a10.477,10.477,0,0,0-5.753,1.611V27.722a15.448,15.448,0,0,1,5.753-1.344c4.832,0,6.862,2.183,6.862,7.289V42.29a27.774,27.774,0,0,0,.192,4.1H88.607Zm-.234-6.71h-.68c-4.185,0-9.173.433-9.173,4.712,0,2.571,1.845,3.534,4.067,3.534,5.675,0,5.785-4.952,5.785-7.061Z",
    transform: "translate(171.036 59.454)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26839",
    "data-name": "Path 26839",
    d: "M82.162,31.21A32.407,32.407,0,0,0,82,26.843h2.427V30.6H84.5c.882-2.19,2.528-4.22,5.024-4.22a7.117,7.117,0,0,1,1.682.231v2.532a6.111,6.111,0,0,0-1.764-.228c-3.827,0-4.868,4.292-4.868,7.819V46.39H82.162Z",
    transform: "translate(184.812 59.454)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26840",
    "data-name": "Path 26840",
    d: "M99.9,45.771a15.961,15.961,0,0,1-5.678,1.08c-6.479,0-8.9-4.37-8.9-10.237,0-5.984,3.3-10.237,8.252-10.237,5.519,0,7.777,4.448,7.777,9.7V37.3H87.972c0,4.142,2.229,7.481,6.446,7.481A12.562,12.562,0,0,0,99.9,43.321ZM98.714,35.229c0-3.407-1.383-6.784-4.988-6.784-3.566,0-5.753,3.573-5.753,6.784Z",
    transform: "translate(192.32 59.454)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26841",
    "data-name": "Path 26841",
    d: "M0,42.623H17.295L29.318,23.874,20.109,11.18Z",
    transform: "translate(0 25.199)",
    fill: "#60b6e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26842",
    "data-name": "Path 26842",
    d: "M23.52,11.19,6.18,11.18,29,42.606l8.8-11.708Z",
    transform: "translate(13.929 25.199)",
    fill: "#1997d4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11604",
    "data-name": "Group 11604",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11603",
    "data-name": "Group 11603",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26843",
    "data-name": "Path 26843",
    d: "M23.7,5.4,6.83,31.913H24.121L36.538,12.37,28.973.513A13.766,13.766,0,0,0,23.7,5.4",
    transform: "translate(15.394 1.156)",
    fill: "#ab97c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26844",
    "data-name": "Path 26844",
    d: "M34.354,7.069A14.177,14.177,0,0,0,25.848.539,18.653,18.653,0,0,0,13.633,1.661l20.038,31.42,17.311-.01s-14.949-23.379-16.628-26",
    transform: "translate(30.728 0.001)",
    fill: "#654a9e"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11606",
    "data-name": "Group 11606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11605",
    "data-name": "Group 11605",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26845",
    "data-name": "Path 26845",
    d: "M6.159,56.584H23.454L38.806,34.679c-4.185-6.638-8.119-12.824-8.119-12.824Z",
    transform: "translate(13.882 49.259)",
    fill: "#7ab943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26846",
    "data-name": "Path 26846",
    d: "M30.8,21.855H13.7S31.245,49.585,31.561,50.07a14.672,14.672,0,0,0,5.018,4.923l7.289-12.635Z",
    transform: "translate(30.872 49.259)",
    fill: "#38b14a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26847",
    "data-name": "Path 26847",
    d: "M55.508,21.858A11.739,11.739,0,0,1,53.936,27.4C49.12,35.769,41.057,49.835,40.354,50.952a11.756,11.756,0,0,1-4.318,3.967,16.451,16.451,0,0,1-7.692,1.666s-5.288-.143-7.614-1.591l19.1-33.138Z",
    transform: "translate(46.724 49.259)",
    fill: "#008c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26848",
    "data-name": "Path 26848",
    d: "M13.192,42.611H30.539l14.2-18.964L36.767,11.178Z",
    transform: "translate(29.734 25.195)",
    fill: "#265fac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26849",
    "data-name": "Path 26849",
    d: "M56.119,42.611a14.782,14.782,0,0,0-2.408-6.4L37.735,11.178h-17.3L40.53,42.611Z",
    transform: "translate(46.063 25.194)",
    fill: "#153e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26850",
    "data-name": "Path 26850",
    d: "M98.7,4.113a5.712,5.712,0,1,1-5.714,5.714A5.717,5.717,0,0,1,98.7,4.113m.013,10.572a4.648,4.648,0,0,0,4.611-4.858,4.623,4.623,0,1,0-9.235,0,4.655,4.655,0,0,0,4.624,4.858m-2.19-8.213h2.551c1.536,0,2.3.618,2.3,1.881a1.712,1.712,0,0,1-1.725,1.858l1.9,2.951H100.4l-1.861-2.951h-.921v2.951h-1.09Zm1.09,2.876h1.3c.84,0,1.38-.172,1.38-1.041,0-.758-.69-.983-1.38-.983h-1.3Z",
    transform: "translate(209.587 9.27)",
    fill: "#153e68"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmnHealthcareLogo);
export default __webpack_public_path__ + "static/media/amn-healthcare-logo.6df8ea69d3b19d9cabd58011f3b63fea.svg";
export { ForwardRef as ReactComponent };